

















































































import { Prop } from 'vue-property-decorator';
import HuntingLicenseOrderForm from '@/modules/HuntingLicenses/LicenseOrder/Form.vue';
import Component, { mixins } from 'vue-class-component';
import { AxiosPromise } from 'axios';
import { HUNTING_LICENSE_ORDERS } from '@/common/api';
import UseBackend from '@/core/mixins/use-backend';
import StatusChip from '@/shared_components/StatusChip.vue';
import { Goal, statusApplication } from '@/common/constants';
import PaymentForm from '@/modules/HuntingLicenses/LicenseOrder/PaymentForm.vue';
import ModalRejectOrderAttachments from '@/shared_components/ModalRejectOrderAttachments.vue';
import HuntingLicenseForm from '@/modules/HuntingLicenses/LicenseOrder/HuntingLicenseForm.vue';
import HuntingLicenseComponent from '@/modules/HuntingLicenses/LicenseOrder/HuntingLicenseComponent.vue';
import BirdsFurryComponent from '@/modules/HuntingLicenses/LicenseOrderReport/BirdsFurryComponent.vue';
import UngulatesComponent from '@/modules/HuntingLicenses/LicenseOrderReport/UngulatesComponent.vue';
import HuntingLicenseOrderStepper from '@/modules/HuntingLicenses/LicenseOrder/ShowWrapper.vue';
import ModalApproveOrder from '@/shared_components/ModalApproveOrder.vue';
import HuntingLicenseOrderReport = Orders.HuntingLicenseOrderReport;

// eslint-disable-next-line no-use-before-define
@Component<LicenseOrderReportShow>({
  components: {
    ModalApproveOrder,
    UngulatesComponent,
    BirdsFurryComponent,
    HuntingLicenseOrderForm,
    StatusChip,
    ModalRejectOrderAttachments,
    HuntingLicenseForm,
    PaymentForm,
    HuntingLicenseComponent,
    HuntingLicenseOrderStepper,
  },
  data() {
    return { GOALS: Goal };
  },
})
export default class LicenseOrderReportShow extends mixins(UseBackend) {
  @Prop({
    type: [String, Number],
    required: true,
  })
  orderId!: string;

  referrer: any = null;

  modalVisibilityReject: boolean = false;

  value: null | Orders.HuntingLicenseOrderReport = null;

  statusApplication = statusApplication;

  modalVisibilityApprove: boolean = false;

  get isCompleted(): boolean {
    return (
      this.value !== null &&
      this.value.huntingLicense !== null &&
      this.value.statusApplicationId === statusApplication.SERVICE_PROVIDE.id
    );
  }

  get canBeTaken(): boolean {
    if (this.value?.userId === this.$currentUser.id) {
      return false;
    }
    return !([
      statusApplication.CANCEL.id,
      statusApplication.DENIED.id,
      statusApplication.SERVICE_PROVIDE.id,
    ] as Array<any>).includes(this.value?.statusApplicationId);
  }

  get doesNotHaveIssue(): boolean {
    return this.value !== null && this.value?.huntingLicense === null;
  }

  get personFio(): string {
    return [this.value?.lastname, this.value?.firstname, this.value?.middlename]
      .filter((s) => s)
      .join(' ');
  }

  get birds(): Array<any> {
    if (this.value?.reportBirdsFurry != null && this.value.reportBirdsFurry.length > 0) {
      return this.value.reportBirdsFurry;
    }
    return [];
  }

  get ungulates(): Array<any> {
    if (this.value?.reportUngulatesBears != null && this.value.reportUngulatesBears.length > 0) {
      return this.value.reportUngulatesBears;
    }
    return [];
  }

  async mounted(): Promise<void> {
    await this.refresh();
    console.log('APPLICATION: ', this.value);
  }

  async refresh() {
    const request = () =>
      this.$http({
        ...HUNTING_LICENSE_ORDERS.GET(+this.orderId),
      }) as AxiosPromise<HuntingLicenseOrderReport>;
    ({ data: this.value } = await this.makeRequest(request));
  }

  toList() {
    if (
      this.referrer !== null &&
      ['hunting-licenses-order-report-list'].includes(this.referrer.name)
    ) {
      this.$router.push(this.referrer);
      return;
    }

    this.$router.push({ name: 'hunting-licenses-order-report-list' });
  }

  // eslint-disable-next-line class-methods-use-this
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      // eslint-disable-next-line no-param-reassign
      vm.referrer = from;
    });
  }

  async takeToWork() {
    const endpoint = HUNTING_LICENSE_ORDERS.TAKE_TO_WORK(+this.orderId);
    ({ data: this.value } = await this.makeRequest(() => this.$http(endpoint)));
  }

  async approveOrder(data) {
    const rejectOrderId = +this.orderId;
    const endpoint = HUNTING_LICENSE_ORDERS.CHANGE_STATUS(rejectOrderId);
    await this.makeRequest(() => this.$http({ ...endpoint, data }));
    this.modalVisibilityApprove = false;
    await this.refresh();
  }

  async rejectOrder(reject) {
    const rejectOrderId = +this.orderId;
    const endpoint = HUNTING_LICENSE_ORDERS.REJECT(rejectOrderId);
    await this.makeRequest(() => this.$http({ ...endpoint, data: reject }));
    this.modalVisibilityReject = false;
    await this.refresh();
  }

  beforeDestroy(): void {
    this.modalVisibilityApprove = false;
    this.modalVisibilityReject = false;
  }
}
